/* Casa de Alix · casa.js (v4, agent home)
   Chargé en <script defer> APRÈS casa-motion.js.
   1. Slider de repli du hero (sans Embla) : flèches, compteur, autoplay, pause.
   2. Toast du panier : role=status, coche, lien « Voir le panier ».
   3. Quick add : /cart/add.js puis /cart.js, compteur [data-cart-count].
      « Les mini boucles » sur la fiche d'une paire ([data-up]) : un « + » ouvre un panneau
      latéral (photos portées, choix d'une mini) ; la paire et la mini partent en un seul POST.
   3b. Panneau « Ajoutée au panier » (remplace le toast après un ajout) : pièce ajoutée,
      progression vers la livraison offerte (window.CASA_FREE_SHIPPING, centimes), mini
      boucles en un clic si le panier n'en a pas. Dialog modal, focus piégé, Échap, clic
      dehors, focus rendu au déclencheur. Le toast reste le repli.
   4. Menu mobile (tiroir) : html.ca-menu-open, focus piégé, Échap, body bloqué
      (position: fixed, iOS compris), inert sur le reste de la page.
   5. Hauteur de ce qui précède le hero dans --ca-top. */
(() => {
  const html = document.documentElement;
  const body = document.body;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------------------------------------------------------- */
  /* 1. Slider de repli (casa-motion.js retire data-slides si Embla est là) */
  /* ---------------------------------------------------------------- */
  document.querySelectorAll('[data-slides]').forEach((root) => {
    const track = root.querySelector('[data-track]');
    if (!track) return;
    const slides = [...track.children];
    if (slides.length < 2) return;
    const cur = root.querySelector('[data-current]');
    let i = 0, timer = null, paused = false, held = false;
    const left = (k) => slides[k].offsetLeft - slides[0].offsetLeft;
    const go = (n) => { i = (n + slides.length) % slides.length; track.scrollTo({ left: left(i), behavior: reduce.matches ? 'auto' : 'smooth' }); };
    const sync = () => {
      const x = track.scrollLeft; let best = 0, d = Infinity;
      slides.forEach((s, k) => { const dd = Math.abs(left(k) - x); if (dd < d) { d = dd; best = k; } });
      i = best; if (cur) cur.textContent = String(i + 1).padStart(2, '0');
    };
    track.addEventListener('scroll', () => { clearTimeout(track._t); track._t = setTimeout(sync, 80); }, { passive: true });
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => { stop(); if (!reduce.matches && !paused && !held && !document.hidden) timer = setInterval(() => go(i + 1), 4500); };
    root.querySelector('[data-prev]')?.addEventListener('click', () => { go(i - 1); start(); });
    root.querySelector('[data-next]')?.addEventListener('click', () => { go(i + 1); start(); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
    // Au toucher, le doigt commande : pas d'autoplay pendant le geste
    track.addEventListener('touchstart', () => { held = true; stop(); }, { passive: true });
    track.addEventListener('touchend', () => { held = false; setTimeout(start, 1200); }, { passive: true });
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { go(i - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { go(i + 1); e.preventDefault(); }
    });
    const pauseBtn = root.querySelector('[data-pause]');
    pauseBtn?.addEventListener('click', () => {
      paused = !paused; pauseBtn.setAttribute('aria-pressed', String(paused));
      pauseBtn.setAttribute('aria-label', paused ? 'Reprendre le défilement' : 'Mettre le défilement en pause');
      paused ? stop() : start();
    });
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
  });

  /* ---------------------------------------------------------------- */
  /* 2. Toast                                                            */
  /* ---------------------------------------------------------------- */
  const toast = document.createElement('div');
  toast.className = 'ca-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite'); toast.setAttribute('aria-atomic', 'true');
  body.appendChild(toast);
  const bag = document.querySelector('.ca-bag[href]');
  const cartUrl = bag ? bag.getAttribute('href') : '/cart';
  const hide = () => { toast.classList.remove('ca-is-on'); clearTimeout(toast._t); };
  const arm = (ms) => { clearTimeout(toast._t); toast._t = setTimeout(hide, ms); };
  const say = (text, opts = {}) => {
    toast.classList.toggle('ca-toast--error', !!opts.error);
    toast.innerHTML = (opts.error ? '' : (window.CASA_ICON_CHECK || '')) + '<span class="ca-toast__text"></span>' + (opts.link ? '<a class="ca-toast__link" href="' + opts.link + '">Voir le panier</a>' : '');
    toast.querySelector('.ca-toast__text').textContent = text;
    toast.classList.add('ca-is-on');
    arm(opts.ms || 4500);
  };
  toast.addEventListener('mouseenter', () => clearTimeout(toast._t));
  toast.addEventListener('mouseleave', () => arm(2000));
  toast.addEventListener('focusin', () => clearTimeout(toast._t));
  toast.addEventListener('focusout', () => arm(2000));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && toast.classList.contains('ca-is-on')) hide(); });
  window.casaToast = say;

  /* ---------------------------------------------------------------- */
  /* 3. Quick add, achat groupé (paire + mini)                           */
  /* ---------------------------------------------------------------- */
  const ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const api = (p) => ROOT + p;
  const FREE = () => (typeof window.CASA_FREE_SHIPPING === 'number' ? window.CASA_FREE_SHIPPING : 4000);
  const chf = (c) => { c = Math.round(Number(c) || 0); return (c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2)) + ' CHF'; };
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  const ICON = (n) => (window.CASA_ICONS && window.CASA_ICONS[n]) || '';
  const sized = (u, w) => (u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '');
  const minis = () => (Array.isArray(window.CASA_MINIS) ? window.CASA_MINIS : []);
  const isMini = (it) => it.product_type === (window.CASA_MINI_TYPE || 'Mini boucles') || minis().some((m) => m.product_id === it.product_id);
  const plural = (n) => 'Panier, ' + n + ' article' + (n > 1 ? 's' : '');
  const setCount = (n) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = n; });
    document.querySelectorAll('.ca-bag').forEach((a) => a.setAttribute('aria-label', plural(n)));
  };
  const fail = async (r) => { let m = 'Impossible d’ajouter cette pièce.'; try { const d = await r.json(); m = d.description || d.message || m; } catch (_) {} return new Error(m); };
  const addItems = async (items) => {
    const r = await fetch(api('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) throw await fail(r);
    const d = await r.json();
    return d.items || [d];
  };
  const addForm = async (fd) => {
    const r = await fetch(api('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
    if (!r.ok) throw await fail(r);
    const d = await r.json();
    return d.items || [d];
  };
  const getCart = async () => (await fetch(api('cart.js'), { headers: { Accept: 'application/json' } })).json();

  /* « Les mini boucles » sur la fiche d'une paire : ligne « + » et panneau latéral */
  const QV_FOCUS = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const initUp = (up) => {
    if (up._up) return;
    const form = document.getElementById(up.dataset.upFor);
    const qv = up.querySelector('[data-qv]');
    if (!form || !qv) return;
    up._up = true;
    up.classList.add('ca-up--js');
    /* Le panneau vit à la racine du body : le reste de la page peut passer en inert */
    body.appendChild(qv);
    const panel = qv.querySelector('.ca-qv__panel');
    const picks = [...qv.querySelectorAll('[data-qv-pick]')];
    const addBtn = qv.querySelector('[data-qv-add]');
    const sum = qv.querySelector('[data-qv-sum]');
    const label = form.querySelector('[data-add-text]');
    const doneLabel = form.querySelector('[data-done-text]');
    const openRow = up.querySelector('.ca-up__open');
    const chosenRow = up.querySelector('[data-up-chosen]');
    const pair = Number(up.dataset.pairPrice) || 0;
    const pairTitle = up.dataset.pairTitle || 'la paire';
    const th = up.dataset.threshold ? Number(up.dataset.threshold) : FREE();
    let draft = null;   /* mini cochée dans le panneau */
    let chosen = null;  /* mini retenue sur la fiche */
    let isOpen = false, opener = null, inerted = [], closeT = null;
    const freeWith = (m) => pair < th && pair + m.price >= th;
    const data = (b) => ({ id: Number(b.dataset.qvPick), price: Number(b.dataset.price) || 0, title: b.dataset.title, img: b.dataset.img });

    const syncPanel = () => {
      picks.forEach((b) => {
        const on = !!draft && Number(b.dataset.qvPick) === draft.id;
        b.setAttribute('aria-pressed', String(on));
        b.closest('.ca-qv__item').classList.toggle('ca-is-picked', on);
      });
      addBtn.disabled = !draft;
      addBtn.textContent = draft ? 'Ajouter les deux, ' + chf(pair + draft.price) : 'Ajouter les deux au panier';
      sum.textContent = draft
        ? pairTitle + ' et ' + draft.title + (freeWith(draft) ? ' : la livraison est offerte' : '')
        : 'Choisissez une mini boucle';
    };
    const syncPage = () => {
      openRow.hidden = !!chosen; chosenRow.hidden = !chosen;
      if (chosen) {
        up.querySelector('[data-up-name]').textContent = chosen.title;
        up.querySelector('[data-up-price]').textContent = '+ ' + chf(chosen.price);
        up.querySelector('[data-up-ship]').hidden = !freeWith(chosen);
        const img = up.querySelector('[data-up-chosen-img]'); if (img && chosen.img) img.src = chosen.img;
      }
      if (label) label.textContent = chosen ? 'Ajouter les deux, ' + chf(pair + chosen.price) : 'Ajouter au panier';
      if (doneLabel) doneLabel.textContent = chosen ? 'Ajoutées au panier' : 'Ajoutée au panier';
    };

    const setInert = (on) => {
      if (on) { inerted = [...body.children].filter((el) => el !== qv && !el.hasAttribute('inert') && el.tagName !== 'SCRIPT' && !/^shopify-(pc|privacy)/.test(el.id || '')); inerted.forEach((el) => el.setAttribute('inert', '')); }
      else { inerted.forEach((el) => el.removeAttribute('inert')); inerted = []; }
    };
    const open = (from) => {
      if (isOpen) return;
      clearTimeout(closeT);
      opener = from || document.activeElement;
      draft = chosen; syncPanel();
      qv.hidden = false; setInert(true);
      html.classList.add('ca-added-open'); window.casaLenis?.stop?.();
      void qv.offsetWidth; qv.classList.add('ca-is-open'); isOpen = true;
      panel.focus({ preventScroll: true });
    };
    const close = (back = true) => {
      if (!isOpen) return;
      isOpen = false; qv.classList.remove('ca-is-open'); setInert(false);
      html.classList.remove('ca-added-open'); window.casaLenis?.start?.();
      closeT = setTimeout(() => { if (!isOpen) qv.hidden = true; }, reduce.matches ? 0 : 400);
      if (back) { const t = (opener && opener.isConnected && !opener.closest('[hidden]')) ? opener : (chosen ? chosenRow.querySelector('button') : openRow); t?.focus({ preventScroll: true }); }
    };

    up.addEventListener('click', (e) => {
      const o = e.target.closest('[data-up-open]'); if (o) { open(o); return; }
      if (e.target.closest('[data-up-clear]')) { chosen = null; syncPage(); openRow.focus({ preventScroll: true }); }
    });
    qv.addEventListener('click', (e) => {
      if (e.target.closest('[data-qv-close]')) {
        /* Fermer sans ajouter garde le choix sur la fiche */
        if (draft && e.target.closest('.ca-qv__skip') == null) { chosen = draft; syncPage(); }
        close(); return;
      }
      const b = e.target.closest('[data-qv-pick]');
      if (b) { const d = data(b); draft = draft && draft.id === d.id ? null : d; syncPanel(); return; }
      if (e.target.closest('[data-qv-add]') && draft) {
        chosen = draft; syncPage(); close(false);
        const submit = form.querySelector('[type="submit"]');
        form.requestSubmit ? form.requestSubmit(submit || undefined) : submit?.click();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      const f = [...panel.querySelectorAll(QV_FOCUS)].filter((el) => el.getClientRects().length);
      if (!f.length) { e.preventDefault(); return; }
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });

    up._pick = () => (chosen ? { id: chosen.id, title: chosen.title } : null);
    up._reset = () => { chosen = null; draft = null; syncPage(); };
    syncPage();
  };
  const upScan = (scope) => scope.querySelectorAll('[data-up]').forEach(initUp);
  upScan(document);
  document.addEventListener('shopify:section:load', (e) => upScan(e.target));

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form.ca-quick, form.ca-js-add'); if (!form) return;
    e.preventDefault();
    const btn = (e.submitter && form.contains(e.submitter) ? e.submitter : null) || form.querySelector('button');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    try {
      if (!(form.action && /\/cart\/add/.test(form.action))) {
        say(form.dataset.added || 'Ajouté au panier', { link: cartUrl });
        form.dispatchEvent(new CustomEvent('casa:added', { bubbles: true }));
        return;
      }
      const fd = new FormData(form);
      /* form.id serait l'input name="id" : on lit l'attribut */
      const fid = form.getAttribute('id');
      const up = fid ? document.querySelector('[data-up][data-up-for="' + CSS.escape(fid) + '"]') : null;
      const pick = up && up._pick ? up._pick() : null;
      let items; let missed = '';
      if (pick) {
        try {
          items = await addItems([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }, { id: pick.id, quantity: 1 }]);
        } catch (err) {
          /* La mini n'a pas pu suivre (stock) : on ajoute au moins la paire */
          items = await addForm(fd);
          missed = pick.title + ' n’a pas pu être ajoutée : ' + err.message;
        }
      } else {
        items = await addForm(fd);
      }
      const cart = await getCart();
      setCount(cart.item_count);
      form.dispatchEvent(new CustomEvent('casa:added', { bubbles: true, detail: { items, cart } }));
      /* La case se décoche une fois l'état « Ajoutées au panier » du bouton passé (2,2 s) */
      if (pick && up._reset) setTimeout(up._reset, 2400);
      const shown = window.casaAdded && window.casaAdded.open({ items, cart, opener: btn, note: missed });
      if (!shown) say(form.dataset.added || 'Ajouté au panier', { link: cartUrl });
    } catch (err) {
      say(err.message || 'Erreur', { error: true });
      form.dispatchEvent(new CustomEvent('casa:error', { bubbles: true, detail: err }));
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
  });

  /* ---------------------------------------------------------------- */
  /* 3b. Panneau « Ajoutée au panier »                                    */
  /* ---------------------------------------------------------------- */
  window.casaAdded = (() => {
    const FOCUS = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let root = null, panel = null, opener = null, isOpen = false, items = [], closeT = null, inerted = [];
    const q = (s) => root.querySelector(s);

    const build = () => {
      root = document.createElement('div');
      root.className = 'ca-added';
      root.setAttribute('data-added', '');
      root.hidden = true;
      root.innerHTML =
        '<div class="ca-added__scrim" data-added-close></div>' +
        '<div class="ca-added__panel" role="dialog" aria-modal="true" aria-labelledby="CaAddedTitle" tabindex="-1" data-lenis-prevent>' +
          '<div class="ca-added__head">' +
            '<h2 class="ca-added__title" id="CaAddedTitle">' + ICON('check') + '<span data-added-title>Ajoutée au panier</span></h2>' +
            '<button class="ca-added__close" type="button" data-added-close aria-label="Fermer">' + (ICON('x') || '<span aria-hidden="true">×</span>') + '</button>' +
          '</div>' +
          '<div class="ca-added__body">' +
            '<ul class="ca-added__items" data-added-items></ul>' +
            '<p class="ca-added__note" data-added-note hidden></p>' +
            '<div class="ca-ship" data-ship>' +
              '<p class="ca-ship__text" data-ship-text aria-live="polite"></p>' +
              '<div class="ca-ship__bar" aria-hidden="true"><span class="ca-ship__fill" data-ship-fill></span></div>' +
            '</div>' +
            '<section class="ca-added__up" data-added-up aria-labelledby="CaAddedUp" hidden>' +
              '<h3 class="ca-label" id="CaAddedUp">Les mini boucles</h3>' +
              '<p class="ca-added__up-text" data-added-up-text></p>' +
              '<ul class="ca-added__minis" data-added-minis></ul>' +
            '</section>' +
            '<p class="ca-sr" role="status" data-added-status></p>' +
          '</div>' +
          '<div class="ca-added__actions">' +
            '<a class="ca-btn" href="' + esc(window.CASA_CART_URL || cartUrl) + '" data-added-cart>Voir le panier' + ICON('arrow') + '</a>' +
            '<button class="ca-btn ca-btn--light" type="button" data-added-close>Continuer mes achats</button>' +
          '</div>' +
        '</div>';
      body.appendChild(root);
      panel = q('.ca-added__panel');
      root.addEventListener('click', (e) => {
        if (e.target.closest('[data-added-close]')) { e.preventDefault(); close(); return; }
        const add = e.target.closest('[data-added-add]');
        if (add) addMini(add);
      });
      document.addEventListener('keydown', (e) => {
        if (!isOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab') return;
        const f = [...panel.querySelectorAll(FOCUS)].filter((el) => el.getClientRects().length);
        if (!f.length) { e.preventDefault(); return; }
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panel || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      });
    };

    const renderItems = () => {
      q('[data-added-items]').innerHTML = items.map((it) => {
        const m = minis().find((x) => x.product_id === it.product_id);
        const shape = m ? m.shape : '';
        const src = sized(it.image || (it.featured_image && it.featured_image.url), 200);
        return '<li class="ca-added__item">' +
          '<span class="ca-added__media">' + (src ? '<img src="' + esc(src) + '" alt="" width="200" height="250">' : '') + '</span>' +
          '<span class="ca-added__info"><span class="ca-added__name">' + esc(it.product_title || it.title) + '</span>' +
          (shape ? '<span class="ca-added__shape">' + esc(shape) + '</span>' : '') +
          '<span class="ca-added__price ca-num">' + chf(it.final_price != null ? it.final_price : it.price) + '</span></span>' +
        '</li>';
      }).join('');
      q('[data-added-title]').textContent = items.length > 1 ? 'Ajoutées au panier' : 'Ajoutée au panier';
    };

    const shipText = (total) => {
      const rem = FREE() - total;
      return rem > 0 ? 'Plus que ' + chf(rem) + ' pour la livraison offerte' : 'La livraison est offerte';
    };
    const ship = (total, from) => {
      const th = FREE(); const rem = th - total;
      const box = q('[data-ship]'); const fill = q('[data-ship-fill]');
      q('[data-ship-text]').innerHTML = rem > 0
        ? ICON('truck') + '<span>Plus que <b class="ca-num">' + chf(rem) + '</b> pour la livraison offerte</span>'
        : ICON('check') + '<span>La livraison est offerte</span>';
      box.classList.toggle('ca-ship--done', rem <= 0);
      const pct = (v) => (th > 0 ? Math.max(0, Math.min(100, (v / th) * 100)) : 100);
      fill.style.transition = 'none';
      fill.style.transform = 'translateX(-' + (100 - pct(from == null ? total : from)) + '%)';
      void fill.offsetWidth;
      fill.style.transition = '';
      requestAnimationFrame(() => { fill.style.transform = 'translateX(-' + (100 - pct(total)) + '%)'; });
    };

    const ups = (cart) => {
      const sec = q('[data-added-up]');
      const lines = cart.items || [];
      const list = minis().filter((m) => !lines.some((i) => i.product_id === m.product_id)).slice(0, 3);
      if (lines.some(isMini) || !list.length) { sec.hidden = true; return; }
      const th = FREE(), total = cart.total_price;
      const low = Math.min.apply(null, list.map((m) => m.price));
      q('[data-added-up-text]').textContent = total < th && total + low >= th
        ? 'Avec une mini, la livraison est offerte.'
        : 'Une mini boucle à ' + chf(low) + ', à porter avec.';
      q('[data-added-minis]').innerHTML = list.map((m) =>
        '<li class="ca-added__mini">' +
          '<a class="ca-added__media" href="' + esc(m.url) + '" tabindex="-1" aria-hidden="true">' + (m.image ? '<img src="' + esc(m.image) + '" alt="" width="240" height="300" loading="lazy">' : '') + '</a>' +
          '<span class="ca-added__info"><a class="ca-added__name" href="' + esc(m.url) + '">' + esc(m.title) + '</a>' +
          (m.shape ? '<span class="ca-added__shape">' + esc(m.shape) + '</span>' : '') +
          '<span class="ca-added__price ca-num">' + chf(m.price) + '</span></span>' +
          '<button class="ca-added__add" type="button" data-added-add="' + m.id + '" data-title="' + esc(m.title) + '" aria-label="Ajouter ' + esc(m.title) + ' au panier, ' + chf(m.price) + '">' + ICON('bag') + '<span>Ajouter</span></button>' +
        '</li>').join('');
      sec.hidden = false;
    };

    const addMini = async (btn) => {
      if (btn.disabled) return;
      const status = q('[data-added-status]');
      const before = Number(q('[data-ship]').dataset.total) || 0;
      btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      try {
        const added = await addItems([{ id: Number(btn.dataset.addedAdd), quantity: 1 }]);
        const cart = await getCart();
        setCount(cart.item_count);
        items = items.concat(added);
        renderItems();
        q('[data-ship]').dataset.total = cart.total_price;
        ship(cart.total_price, before);
        ups(cart);
        status.textContent = (btn.dataset.title || 'La mini') + ' ajoutée au panier. ' + shipText(cart.total_price) + '.';
        const go = q('[data-added-cart]'); if (go) go.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('casa:added', { detail: { items: added, cart } }));
      } catch (err) {
        btn.disabled = false; btn.removeAttribute('aria-busy');
        const t = q('[data-added-up-text]'); if (t) t.textContent = err.message;
        status.textContent = err.message;
      }
    };

    const setInert = (on) => {
      if (on) {
        inerted = [...body.children].filter((el) => el !== root && el !== toast && !el.hasAttribute('inert') && el.tagName !== 'SCRIPT' && !/^shopify-(pc|privacy)/.test(el.id || ''));
        inerted.forEach((el) => el.setAttribute('inert', ''));
      } else {
        inerted.forEach((el) => el.removeAttribute('inert'));
        inerted = [];
      }
    };

    const open = (data) => {
      try {
        if (!data || !data.cart) return false;
        if (!root) build();
        clearTimeout(closeT);
        hide();
        items = (data.items || []).slice();
        const cart = data.cart;
        const addedSum = items.reduce((n, it) => n + (Number(it.final_price != null ? it.final_price : it.price) || 0), 0);
        renderItems();
        const note = q('[data-added-note]');
        note.textContent = data.note || ''; note.hidden = !data.note;
        q('[data-ship]').dataset.total = cart.total_price;
        q('[data-added-status]').textContent = '';
        ups(cart);
        if (!isOpen) {
          opener = data.opener || document.activeElement;
          root.hidden = false;
          setInert(true);
          html.classList.add('ca-added-open');
          window.casaLenis?.stop?.();
          void root.offsetWidth;
          root.classList.add('ca-is-open');
          isOpen = true;
          panel.focus({ preventScroll: true });
        }
        ship(cart.total_price, Math.max(0, cart.total_price - addedSum));
        return true;
      } catch (err) {
        if (root) { root.hidden = true; root.classList.remove('ca-is-open'); }
        setInert(false); html.classList.remove('ca-added-open'); isOpen = false;
        return false;
      }
    };

    const close = () => {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('ca-is-open');
      setInert(false);
      html.classList.remove('ca-added-open');
      window.casaLenis?.start?.();
      closeT = setTimeout(() => { if (!isOpen) root.hidden = true; }, reduce.matches ? 0 : 360);
      const back = opener && opener.isConnected ? opener : document.querySelector('.ca-bag');
      back?.focus({ preventScroll: true });
    };

    return { open, close, isOpen: () => isOpen };
  })();

  /* ---------------------------------------------------------------- */
  /* 4. Tiroir mobile                                                    */
  /* ---------------------------------------------------------------- */
  const drawer = document.querySelector('[data-drawer]');
  if (drawer) {
    const toggles = [...document.querySelectorAll('[data-menu-toggle]')];
    const closers = [...drawer.querySelectorAll('[data-menu-close]')];
    const FOCUS = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    let opener = null, y = 0, open = false;
    const outside = () => [...body.children].filter((el) => el !== drawer && !el.contains(drawer) && el !== toast && !el.hasAttribute('data-added'))
      .concat([...document.querySelectorAll('.ca-header, .ca-announce')].filter((el) => !el.contains(drawer)));
    drawer.setAttribute('inert', '');
    const focusables = () => [...drawer.querySelectorAll(FOCUS)].filter((el) => el.getClientRects().length);
    const setOpen = (v) => {
      if (v === open) return; open = v;
      toggles.forEach((b) => b.setAttribute('aria-expanded', String(v)));
      if (v) {
        opener = document.activeElement;
        y = scrollY;
        html.classList.add('ca-menu-open');
        body.style.top = -y + 'px'; body.classList.add('ca-locked');
        window.casaLenis?.stop?.();
        outside().forEach((el) => el.setAttribute('inert', ''));
        drawer.removeAttribute('inert');
        requestAnimationFrame(() => (closers[0] || focusables()[0])?.focus({ preventScroll: true }));
      } else {
        drawer.setAttribute('inert', '');
        outside().forEach((el) => el.removeAttribute('inert'));
        html.classList.remove('ca-menu-open');
        body.classList.remove('ca-locked'); body.style.top = '';
        scrollTo({ top: y, left: 0, behavior: 'auto' });
        window.casaLenis?.start?.();
        (opener && opener.isConnected ? opener : toggles[0])?.focus({ preventScroll: true });
      }
    };
    toggles.forEach((b) => b.addEventListener('click', () => setOpen(!open)));
    closers.forEach((b) => b.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); setOpen(false); return; }
      if (e.key !== 'Tab') return;
      const f = focusables(); if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    // Un lien vers une ancre de la même page : on referme avant de défiler
    drawer.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]'); if (!a) return;
      const u = new URL(a.href, location.href);
      if (u.pathname === location.pathname && u.hash) setOpen(false);
    });
    // Retour au grand écran : le tiroir n'existe plus
    const wide = matchMedia('(min-width: 861px)');
    (wide.addEventListener ? wide.addEventListener('change', (e) => { if (e.matches) setOpen(false); }) : wide.addListener((e) => { if (e.matches) setOpen(false); }));
    window.addEventListener('pageshow', (e) => { if (e.persisted) setOpen(false); });
  }

  /* ---------------------------------------------------------------- */
  /* 5. Hauteur de ce qui précède le hero : --ca-top                      */
  /* ---------------------------------------------------------------- */
  const setTop = () => {
    const a = document.querySelector('.ca-announce');
    const h = document.querySelector('.ca-header');
    html.style.setProperty('--ca-top', ((a ? a.offsetHeight : 0) + (h ? h.offsetHeight : 0)) + 'px');
  };
  setTop();
  addEventListener('resize', setTop, { passive: true });
  addEventListener('load', setTop);
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(setTop);
    document.querySelectorAll('.ca-announce, .ca-header').forEach((el) => ro.observe(el));
  }
})();
